import * as React from 'react';

export function SvgGoogleSheets(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14_172)">
        <path
          d="M18.6875 22H5.3125C4.59062 22 4 21.3864 4 20.6364V3.36364C4 2.61364 4.59062 2 5.3125 2H15.1875L20 7V20.6364C20 21.3864 19.4094 22 18.6875 22Z"
          fill="#26A668"
        />
        <path d="M15.1874 2L19.9999 7H15.1874V2Z" fill="#207A50" />
        <path
          d="M8 9.84415V17.3658H15.9885V9.84415H8ZM11.495 16.3283H8.99856V15.0315H11.495V16.3283ZM11.495 14.2534H8.99856V12.9565H11.495V14.2534ZM11.495 12.1784H8.99856V10.8816H11.495V12.1784ZM14.9899 16.3283H12.4935V15.0315H14.9899V16.3283ZM14.9899 14.2534H12.4935V12.9565H14.9899V14.2534ZM14.9899 12.1784H12.4935V10.8816H14.9899V12.1784Z"
          fill="#FDFFFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_14_172">
          <rect
            width="16"
            height="20"
            fill="white"
            transform="translate(4 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
